import useSurveys from './useSurveys';

import type { SurveyName } from '@Types/Survey';

const useSurveyByName = (name: SurveyName) => {
  const { data: surveys } = useSurveys();

  const matchedSurvey = (surveys || []).find((survey) => survey.name === name);

  return { survey: matchedSurvey };
};

export default useSurveyByName;
